/**
 * Owners: what happened in the team lately: who joined and with which invite role, roles
 * changed, people removed or gone, invite links made or withdrawn, the server's admin's
 * changes. Asked again whenever the team changes.
 */
import { For, createResource, type JSX } from "solid-js";
import type { TeamView } from "@protocol/TeamView";
import { formatDate } from "../shared/ui";
import { usePages } from "./context";

/** The activity of `team`. */
export function TeamActivity(props: { team: TeamView }): JSX.Element {
  const { accounts, server } = usePages();
  // Keyed on the view: a change to the team (a new member, a role) loads the lines again.
  const [lines] = createResource(
    () => props.team,
    (team) => accounts.call(server, (a) => a.teamActivity(team.id), true),
  );
  return (
    <section class="team-section" id="team-activity">
      <h3>Activity</h3>
      <ul class="activity-list">
        <For each={lines() ?? []} fallback={<li class="muted small">Nothing yet.</li>}>
          {(line) => (
            <li data-activity={line.action}>
              <span class="muted small">{formatDate(line.at)}</span> <b>{line.by ?? "The server's admin"}</b> {line.detail}
            </li>
          )}
        </For>
      </ul>
    </section>
  );
}
